import { DATA_SLICE_KEY } from './dataSlice';

// ===== Data Slice Selectors =====

/**
 * Selects the current status of Google Maps library loading.
 * @param {Object} state - Redux state
 * @returns {string} Status (Idle, Loading, Succeeded, Failed)
 */
export function selectMapLibraryStatus(state) {
  return state[DATA_SLICE_KEY].mapLibraryStatus;
}

/**
 * Selects any error that occurred during Google Maps library loading.
 * @param {Object} state - Redux state
 * @returns {string|null} Error message or null if no error
 */
export function selectMapLibraryError(state) {
  return state[DATA_SLICE_KEY].mapLibraryError;
}